import React, { useEffect } from 'react';
import { Routes, Route, useLocation, Navigate } from 'react-router-dom';
import Home from '../Pages/Home';
import LoginPage from '../Pages/LoginPage';
import StoreProducts from '../Pages/StoreProducts';
import CartPage from '../Pages/CartPage';
import OrderHistory from '../Pages/OrderHistory';
import OrderTracking from '../Pages/OrderTracking';
import ProfileInfo from '../Pages/ProfileInfo';
import ProductDetails from '../Pages/ProductDetails';
import EyePowerFinderPage from '../Pages/EyePowerFinderPage';
import SignupPage from '../Pages/SignupPage';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

const AppRoutes = () => {
  return (
    <>
    <ScrollToTop />
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<Navigate to="/signup" replace />} />
      <Route path="/signup" element={<SignupPage />} />
      <Route path="/products/:category" element={<StoreProducts />} />
      <Route path="/product/:id" element={<ProductDetails />} />
      <Route path="/cart" element={<CartPage />} />
      <Route path="/orders" element={<OrderHistory />} />
      <Route path="/orders/track/:orderId" element={<OrderTracking />} />
      <Route path="/profile" element={<ProfileInfo />} />
      <Route path="/eye-power-finder" element={<EyePowerFinderPage />} />
    </Routes>
    </>
  );
};

export default AppRoutes;
